<div class="sidesheet mat-elevation-z2">
    <div>
        <mat-form-field class="full-width">
            <mat-select [(value)]="mesSeleccionado" (valueChange)="cambiarMes($event)" placeholder="Seleccione un mes">
                <mat-option *ngFor="let mes of mesesDisponibles" [value]="mes.id">{{mes.label}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <nivelaciones-convenciones [direccion]="'vertical'" [completo]="'true'" [asistencia]="'true'"></nivelaciones-convenciones>
</div>

<section *ngIf="dataReady">
    <div style="width: calc(100% - 48px); margin: 48px auto; padding-right: 332px; padding-left: 15px;">
        <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z2">
            <ng-container *ngFor="let col of displayedColumns" matColumnDef="{{col}}">

                <!-- Inicio fila -->
                <ng-container *ngIf="col == 'Alumno'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="double"> {{col}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="double">
                        <span [ngClass]="{'hide': !element.showName}">
                            {{element.alumno.apellidosNombres}}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container *ngIf="col == 'Franja'">
                    <mat-header-cell *matHeaderCellDef> {{col}}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.horaCita}}</mat-cell>
                </ng-container>

                <ng-container *ngIf="col != 'Alumno' && col != 'Franja'">
                    <mat-header-cell style="text-align: center" *matHeaderCellDef>
                        {{col}}
                        <!--<button mat-icon-button *ngIf="isFecha(col)"-->
                        <!--(click)="asistenciaMasiva(col)">-->
                        <!--<mat-icon>fiber_manual_record</mat-icon>-->
                        <!--</button>-->
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element;" class="mat-column-select"
                              style="text-align: center; display: flex; justify-content: space-around;">
                        <ng-container
                                *ngIf="(element.fechas | fechasFilter: col).conflicto && (element.fechas | fechasFilter: col).conflicto.isConflicto; else editable">
                            <mat-icon
                                    matTooltip="Reservado por {{(element.fechas | fechasFilter: col).conflicto.profesor}} {{(element.fechas | fechasFilter: col).conflicto.materia}}">
                                not_interested
                            </mat-icon>
                        </ng-container>
                        <ng-template #editable>
                            <ng-container
                                    *ngIf="!(element.fechas | fechasFilter: col).asistencia && (element.fechas | fechasFilter: col).isEditable">
                                <mat-checkbox #controlCita color="primary"
                                              [value]="(element.fechas | fechasFilter: col)"
                                              [checked]="(element.fechas | fechasFilter: col).citado"
                                              (change)="cambiarCitacion($event, controlCita, element.alumno.id, element.hora)">
                                </mat-checkbox>
                            </ng-container>
                            <ng-container *ngIf="!(element.fechas | fechasFilter: col).asistencia &&
                                    !(element.fechas | fechasFilter: col).isEditable &&
                                    (element.fechas | fechasFilter: col).citado">
                            <span style='cursor: no-drop' class="circulo" [ngClass]="{'neutral': (element.fechas | fechasFilter: col).noReportaAsistencia,
                                      'error': (element.fechas | fechasFilter: col).ausente,
                                      'warn': (element.fechas | fechasFilter: col).retardo,
                                      'success': (element.fechas | fechasFilter: col).presente}"></span>
                            </ng-container>
                            <ng-container
                                    *ngIf="(element.fechas | fechasFilter: col).asistencia && (element.fechas | fechasFilter: col).citado">
                                <span class="circulo error" *ngIf="(element.fechas | fechasFilter: col).ausente"
                                      (click)="setAsistencia('presente', element, col)"></span>
                                <span class="circulo warn" *ngIf="(element.fechas | fechasFilter: col).retardo"
                                      (click)="setAsistencia('ausente', element, col)"></span>
                                <span class="circulo success" *ngIf="(element.fechas | fechasFilter: col).presente"
                                      (click)="setAsistencia('retardo', element, col)"></span>
                                <span class="circulo neutral"
                                      *ngIf="(element.fechas | fechasFilter: col).noReportaAsistencia"
                                      (click)="setAsistencia('presente', element, col)"></span>
                            </ng-container>
                        </ng-template>
                    </mat-cell>
                </ng-container>
                <!-- Fin fila -->

            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;">
            </mat-row>
        </mat-table>
    </div>
</section>